<app-navbar-style-one></app-navbar-style-one>

<div class="home-slider owl-carousel owl-theme">
    <div class="slider-item" 
        style="background-image: url('../../../assets/img/home2/order-online.jpg');">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="slider-content">
                        <h1>Cart</h1>
                        <p>"Craving wings or sandwiches? Order online and we'll have it hot and ready!"</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="cart-section mt-5">
    <div class="cart-container">
        <div class="cart-content">
            <!-- Left side - Cart items -->
            <div class="cart-items">
                <div *ngIf="!isLoading">
                    <div class="cart-item" *ngFor="let item of cartItems; let i = index">
                        <div class="item-image">
                            <img [src]="item.avatar || 'assets/images/default-food.png'" alt="{{item.name}}">
                        </div>
                        
                        <div class="item-details">
                            <h3>{{item.name}}</h3>
                            
                            <!-- Display components and size -->
                             <p class="description">
                                <span>{{item.components}}</span>
                            </p>
                            <p class="description mb-0">
                                <!-- <span>{{item.components}}</span> -->
                                <span *ngIf="item.selectedTypeId" class="size-label ms-0">
                                    <span class="description mb-0">Type: </span>
                                    <span *ngFor="let selectedType of item.types">
                                        <span *ngIf="selectedType.id == item.selectedTypeId" style="color: #c71d1d;">{{selectedType.name}}</span>
                                    </span>
                                    <!-- ({{item.selectedTypeId == item.types.id }}) -->
                                </span>
                            </p>

                            <!-- Display sides -->
                            <div *ngIf="item.selectedFreeSides && item.selectedFreeSides.length > 0">
                                <span class="description mb-0">Free Sides: </span>
                                <span class="mt-0" *ngFor="let side of item.selectedFreeSides; let last = last" style="color: #c71d1d;">
                                    {{ side.name }}<span *ngIf="!last">, </span>
                                </span>
                            </div>
                            
                            <!-- Display unique extras with quantities -->
                            <!-- <div *ngIf="item.selectedExtraId && item.selectedExtraId.length > 0">
                                <span class="description mb-0">Extras: </span>
                                <span class="mt-0" *ngFor="let extra of getUniqueExtrasWithCount(item); let last = last" style="color: #c71d1d;">
                                    {{ extra.name }}<span *ngIf="extra.count > 1"> ({{ extra.count }}x)</span><span *ngIf="!last">, </span>
                                </span>
                            </div> -->
                            <div *ngIf="item.selectedExtraId && item.selectedExtraId.length > 0">
                                <span class="description mb-0">Extras: </span>
                                <span class="mt-0" *ngFor="let extra of item.selectedExtraId; let last = last" style="color: #c71d1d;">
                                    {{ extra.name }}<span *ngIf="extra.quantity > 1"> ({{ extra.quantity }}x)</span><span *ngIf="!last">, </span>
                                </span>
                            </div>
                            
                            <!-- Price and quantity with discount display -->
                            <div class="price-quantity">
                                <div class="price-container">
                                    <span *ngIf="item.offer" class="original-price">
                                        ${{getOriginalItemPrice(item) | number:'1.2-2'}}
                                    </span>
                                    <span class="final-price" [class.discounted]="item.offer">
                                        ${{getItemPrice(item) | number:'1.2-2'}}
                                    </span>
                                    <span *ngIf="item.offer" class="discount-badge">
                                        {{getItemDiscountText(item)}}
                                    </span>
                                    <!-- Show item total (unit price * quantity) -->
                                    <!-- <div class="item-total" style="font-size: 0.9em; color: #666;">
                                        Total: ${{getItemTotalPrice(item) | number:'1.2-2'}}
                                    </div> -->
                                </div>

                                
                                <div class="item-actions">
                                    <button class="quantity-btn" (click)="decreaseQuantity(i)" 
                                            [disabled]="item.quantity <= 1">-</button>
                                    <span class="quantity">{{item.quantity}}</span>
                                    <button class="quantity-btn" (click)="increaseQuantity(i)">+</button>
                                </div>
                            </div>
                        </div>
                        <button class="delete-btn" (click)="removeItem(i)">
                            <i class="bx bx-trash"></i>
                        </button>
                    </div>
                </div>

                <!-- Loading state -->
                <div class="account-card text-center" *ngIf="isLoading">
                    <div class="spinner-grow" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>

                <!-- Empty cart state -->
                <div class="alert alert-danger text-center" *ngIf="cartItems.length === 0 && !isLoading">
                    <div class="item-image">
                        <img src="../../../../assets/img/home2/empty-cart.png" width="200" alt="Empty Cart">
                    </div>
                    
                    <div class="item-details">
                        <h3>Your cart is empty</h3>
                        <p class="description">You haven't added any items to your cart yet.</p>
                    </div>
                </div>

                <!-- Totals section -->
                <div class="total-section">
                    <div class="total-row">
                        <span>Subtotal:</span>
                        <span>${{subtotal | number:'1.2-2'}}</span>
                    </div>
                    <div class="total-row" *ngIf="cartDiscount > 0">
                        <span>Items Discount:</span>
                        <span class="text-danger">- ${{cartDiscount | number:'1.2-2'}}</span>
                    </div>
                    <div class="total-row" *ngIf="couponApplied">
                        <span>Coupon Discount:</span>
                        <span class="text-danger">
                            <span *ngIf="couponType === 'percentage'">- ${{subtotal * (couponValue / 100) | number:'1.2-2'}}</span>
                            <span *ngIf="couponType === 'value'">- ${{couponValue | number:'1.2-2'}}</span>
                        </span>
                    </div>
                    <div class="total-row grand-total">
                        <span>Total:</span>
                        <span>${{total | number:'1.2-2'}}</span>
                    </div>
                </div>
            </div>

            <!-- Right side - Payment and summary -->
            <div class="cart-summary">
                <div class="summary-section payment-methods">
                    <h3>Payment</h3>
                    <div class="payment-option d-flex align-items-center">
                        <input type="radio" id="card" name="payment" [(ngModel)]="paymentMethod" (ngModelChange)="changePayment('card')" value="card">
                        <label style="font-size: 18px;" for="card">Card</label>
                    </div>
                    <div class="payment-option d-flex align-items-center">
                        <input type="radio" id="cash" name="payment" [(ngModel)]="paymentMethod" (ngModelChange)="changePayment('cash')" value="cash">
                        <label style="font-size: 18px;" for="cash">Cash</label>
                    </div>
                </div>

                <div class="summary-section coupon-section">
                    <h3 class="mb-4">Coupon</h3>
                    <div class="coupon-input">
                        <input type="text" placeholder="Enter coupon code" [(ngModel)]="couponCode">
                        <button (click)="applyCoupon()">Apply</button>
                    </div>
                    <p class="coupon-message text-success" *ngIf="couponApplied">
                        Coupon applied! 
                        <span *ngIf="couponType === 'percentage'">{{couponValue}}% discount</span>
                        <span *ngIf="couponType === 'value'">${{couponValue | number:'1.2-2'}} off</span>
                    </p>
                    <p *ngIf="couponApplied">
                        <a class="text-danger" href="javascript:void(0)" (click)="removeCoupon()">Remove Coupon</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12 text-center">
            <button [disabled]="cartItemsLength == 0" class="checkout-btn" (click)="proceedToCheckout()">
                Proceed To Checkout
            </button>
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>